import { connect } from "react-redux";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Loading from "./../../components/loading/Loading";
import * as ReactSpark from "react-spark";
import * as rlabActions from "../../components/rlab/actions/rlab-actions";
import * as rlabSelectors from "../../components/rlab/selectors/rlab-selectors";
import services from "../../../services";

const { coreAPIInstance } = services;
const { Stack, Type, Box } = ReactSpark;
const loadingStyle = {
  WebkitTransition: "1s",
  MozTransition: "1s",
  OTransition: "1s",
  transition: "1s",
  opacity: 0,
  visibility: "hidden"
};
const loadedStyle = {
  WebkitTransition: "1s",
  MozTransition: "1s",
  OTransition: "1s",
  transition: "1s",
  opacity: 1,
  visibility: "visible"
};
export class Page extends Component {
  static defaultProps = {
    loading: false,
    heading: "",
    generatingRlabVariants: false,
    rlabReset: () => {},
    generateRlabVariants: () => {},
    api: coreAPIInstance
  };

  static propTypes = {
    id: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    heading: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element)
    ]).isRequired,
    generateRlabVariants: PropTypes.func.isRequired,
    generatingRlabVariants: PropTypes.bool,
    rlabPage: PropTypes.string
  };

  componentWillMount() {
    const { rlabReset } = this.props;
    rlabReset();
  }

  componentDidUpdate(prevProps) {
    const { api, generateRlabVariants, loading, rlabPage } = this.props;
    if (rlabPage) {
      const isLoadingFinished = prevProps.loading === true && loading === false;
      if (isLoadingFinished) {
        generateRlabVariants(api, rlabPage);
      }
    }
  }

  render() {
    const {
      id,
      loading,
      children,
      heading,
      padding,
      generatingRlabVariants,
      className = "sprk-o-CenteredColumn",
    } = this.props;

    const loadingSomething = loading || generatingRlabVariants;

    return (
      <Stack id={id} itemSpacing="medium" className={className}>
        <Stack.Item>
          <Box padding={padding}>
            <Loading isLoading={loadingSomething} />
            <div
              id="content-wrapper"
              style={loadingSomething ? loadingStyle : loadedStyle}
            >
              {!loadingSomething && (
                <Fragment>
                  {heading && (
                    <Type.DisplayTwo className="sprk-b-PageTitle">
                      {heading}
                    </Type.DisplayTwo>
                  )}
                  {children}
                </Fragment>
              )}
            </div>
          </Box>
        </Stack.Item>
      </Stack>
    );
  }
}

const mapStateToProps = state => {
  return {
    generatingRlabVariants: rlabSelectors.generatingVariants(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    generateRlabVariants: (api, page) => {
      dispatch((_, getState) => {
        const state = getState();
        // Check the condition in the state
        if (state && state.loan && state.loan.loanJson && state.loan.loanJson.loanId) {
          dispatch(rlabActions.generateVariantsAuthenticated({ api: coreAPIInstance, page }, state.loan.loanJson.loanId));
        } else {
          dispatch(rlabActions.generateVariants({ api: coreAPIInstance, page }))
        }
      })
    },
    rlabReset: () => {
      dispatch(rlabActions.reset());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Page);
